import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import PlayerTimestamps from './PlayerTimestamps';
import { Col, Row } from 'reactstrap';

function PlayerOptions({ total_call_duration, coveredCallDuration, setCoveredCallDuration, setCurrentPosition, audioRef, scrolledTime, setScrolledTime, transcriptScrolling, setSeekBarStickPosition, upcomingBarPosition, seekBarStickPosition, showUpcomingBar, audio }) {

  const [currentTime, setCurrentTime] = useState(0);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [volume, setVolume] = useState(1);
  const [showVolume, setShowVolume] = useState(false);
  const [volumeTimer, setVolumeTimer] = useState(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const covered_milliseconds = parseInt(currentTime * 1000);
    const percentage = (covered_milliseconds / total_call_duration.total_call_duration_milliseconds * 100);
    if (percentage > 100 || percentage < 0) {
      return;
    }
    if (!transcriptScrolling) {
      setCurrentPosition(percentage);
    }
    setSeekBarStickPosition(percentage);
    setCoveredCallDuration({
      covered_call_duration_milliseconds: covered_milliseconds,
      covered_call_duration_seconds: parseInt(covered_milliseconds / 1000 % 60),
      covered_call_duration_minutes: parseInt(covered_milliseconds / 1000 / 60 % 60),
      covered_call_duration_hours: parseInt(covered_milliseconds / 1000 / 60 / 60)
    })
  }, [currentTime]);

  function handleTimeUpdate() {
    setCurrentTime(audioRef.current.currentTime);
  }

  function handlePlayPause() {
    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setPlaying(!playing);
  }

  function handleSeek(e) {
    const newTime = e.target.value;
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  }

  useEffect(() => {
    if (scrolledTime) {
      audioRef.current.currentTime = scrolledTime;
      setCurrentTime(scrolledTime);
      setScrolledTime(null);
      const covered_milliseconds = parseInt(scrolledTime * 1000);
      const percentage = (covered_milliseconds / total_call_duration.total_call_duration_milliseconds * 100);
      if (percentage > 100 || percentage < 0) {
        return;
      }
      setCurrentPosition(percentage);
    }
  }, [scrolledTime]);

  function handlePlaybackRateChange(e) {
    const newPlaybackRate = e.target.value;
    audioRef.current.playbackRate = newPlaybackRate;
    setPlaybackRate(newPlaybackRate);
  }

  function handleVolumeChange(e) {
    const newVolume = e.target.value;
    audioRef.current.volume = newVolume;
    setVolume(newVolume);
  }

  function handleVolumeButtonHover() {
    setShowVolume(true);
    clearInterval(volumeTimer);
  }

  function handleVolumeSliderHover() {
    clearTimeout(volumeTimer);
    setVolumeTimer(null);
  }

  function handleVolumeSliderLeave() {
    // Delay hiding the volume slider by 1.5 second
    setVolumeTimer(setTimeout(() => {
      setShowVolume(false);
    }, 1500));
  }

  function handleBackward() {
    audioRef.current.currentTime -= 10;
  }

  function handleForward() {
    audioRef.current.currentTime += 10;
  }

  //functions which are called upon moving slider
  const handleSliderClick = (event) => {
    const clickedPosition = event.clientX; // get the x-coordinate of the click event
    const slider = document.querySelector(".slider");
    const sliderRect = slider.getBoundingClientRect();
    const sliderStart = sliderRect.left // get the actual start position of the slider
    const sliderWidth = slider.clientWidth; // get the width of the slider element

    // check that clickedPosition is within the bounds of the slider
    if (clickedPosition >= sliderStart && clickedPosition <= sliderStart + sliderWidth) {
      const percentageClicked = ((clickedPosition - sliderStart) / sliderWidth) * 100; // calculate the percentage of the width where the user clicked
      audioRef.current.currentTime = (percentageClicked / 100) * total_call_duration.total_call_duration_milliseconds / 1000; // calculate the new time based on the percentage clicked
      setCurrentTime((percentageClicked / 100) * total_call_duration.total_call_duration_milliseconds / 1000);
    }
  };

  const handleSliderDragStart = (event) => {
    event.preventDefault();
    document.addEventListener("mousemove", handleSliderDrag);
    document.addEventListener("mouseup", handleSliderDragEnd);
  }

  const handleSliderDrag = (event) => {
    const draggedPosition = event.clientX; // get the x-coordinate of the drag event
    const sliderWidth = document.querySelector(".slider").offsetWidth; // get the width of the slider element
    const sliderStart = document.querySelector(".slider").getBoundingClientRect().left;
    const percentageDragged = ((draggedPosition - sliderStart) / sliderWidth) * 100; // calculate the percentage of the width where the user dragged
    if (percentageDragged > 100 || percentageDragged < 0) {
      return;
    }
    const covered_milliseconds = (percentageDragged / 100) * total_call_duration.total_call_duration_milliseconds;
    audioRef.current.currentTime = parseInt(covered_milliseconds) / 1000; // calculate the new time based on the percentage clicked
    setCoveredCallDuration({
      covered_call_duration_milliseconds: covered_milliseconds,
      covered_call_duration_seconds: parseInt(covered_milliseconds / 1000 % 60),
      covered_call_duration_minutes: parseInt(covered_milliseconds / 1000 / 60 % 60),
      covered_call_duration_hours: parseInt(covered_milliseconds / 1000 / 60 / 60)
    })
    // setCurrentTime((percentageDragged / 100) * total_call_duration.total_call_duration_milliseconds / 1000);
    setSeekBarStickPosition(percentageDragged);
  }

  const handleSliderDragEnd = () => {
    document.removeEventListener("mousemove", handleSliderDrag);
    document.removeEventListener("mouseup", handleSliderDragEnd);
  }

  return (
    <Row>
      <Col md='1'></Col>
      <Col md='11'>
        <audio
          ref={audioRef}
          src={audio}
          onTimeUpdate={handleTimeUpdate}
        />
        <Row className='d-flex align-items-center justify-content-center mb-3'>
          <Col md='5' className='d-flex align-items-center'>
            <Col className='d-flex justify-content-end'>
              <select
                className='ms-auto'
                id="playbackRate"
                name="playbackRate"
                value={playbackRate}
                onChange={handlePlaybackRateChange}
                style={{ cursor: 'pointer' }}
              >
                <option value={0.5}>0.5x</option>
                <option value={1}>1x</option>
                <option value={1.5}>1.5x</option>
                <option value={2}>2x</option>
              </select>
            </Col>
            <Col className='d-flex align-items-center gap-3'>
              <Col>
                <div className='d-flex align-items-center ms-4'>
                  <span className='font-weight-semibold'>10s</span>
                  <i className='bx bx-rewind-circle h4 mb-0 text-black ms-2' onClick={handleBackward} style={{ cursor: 'pointer' }} />
                </div>
              </Col>
              {
                playing ?
                  <Col><div className='bg-primary d-flex justify-content-center align-items-center rounded-circle' style={{ width: "40px", height: "40px" }} onClick={handlePlayPause}>
                    <i className='bx bx-pause text-light fs-24' style={{ cursor: 'pointer' }} />
                  </div>
                  </Col>
                  :
                  <Col><div className='bg-primary d-flex justify-content-center align-items-center rounded-circle' style={{ width: "40px", height: "40px" }} onClick={handlePlayPause}>
                    <i className='bx bx-play text-light fs-24' style={{ cursor: 'pointer' }} />
                  </div>
                  </Col>
              }
              <Col>
                <div className='d-flex align-items-center me-4'>
                  <i className='bx bx-fast-forward-circle h4 mb-0 text-black me-1' onClick={handleForward} style={{ cursor: 'pointer' }} />
                  <span className='font-weight-semibold'>10s</span>
                </div>
              </Col>
            </Col>
            <Col md='3' className='d-flex align-items-center'>
              <i
                className='bx bx-volume-full h4 mb-0 text-black me-2'
                onMouseEnter={handleVolumeButtonHover}
                onMouseLeave={handleVolumeSliderLeave}
                style={{ cursor: 'pointer' }}
              />
              {showVolume &&

                <input
                  style={{ cursor: 'pointer' }}
                  type="range"
                  className='me-2'
                  id="volume"
                  name="volume"
                  min={0}
                  max={1}
                  step={0.01}
                  value={volume}
                  onChange={handleVolumeChange}
                  onMouseEnter={handleVolumeSliderHover}
                  onMouseLeave={handleVolumeSliderLeave}
                />
              }
              <span className='font-weight-semibold'>{(volume * 100).toFixed(0)}%</span>
            </Col>
          </Col>
        </Row>
        <PlayerTimestamps
          converedCallDuration={coveredCallDuration}
          total_call_duration={total_call_duration}
        />

        <div className="slider" onClick={handleSliderClick}
          style={{ width: '100%', height: '10px', backgroundColor: '#dedede', position: 'relative', borderRadius: '5px', cursor: 'pointer' }}
        >
          <div
            style={{ width: `${seekBarStickPosition}%`, height: '10px', backgroundColor: '#D5ECFB', borderRadius: '5px' }}
          ></div>
          <div onMouseDown={handleSliderDragStart} onMouseUp={handleSliderDragEnd}
            style={{ zIndex: '6', borderRadius: '50%', backgroundColor: "#2F9EE9", width: "17px", height: "17px", position: 'absolute', left: `${seekBarStickPosition - 1}%`, bottom: '-4px' }}
          >
          </div>
          <div style={{ height: '120px', backgroundColor: '#2F9EE9', width: '1px', zIndex: 5, position: 'absolute', left: `${seekBarStickPosition}%` }}>
          </div>
          {/* {
            showUpcomingBar &&
            <div style={{ height: '127px', backgroundColor: '#2F9EE9', width: '1px', zIndex: 5, position: 'absolute', left: `${upcomingBarPosition}%` }}>
            </div>
          } */}
        </div>
      </Col>
    </Row>
  );
}

export default PlayerOptions;